import React from "react";
import { createBrowserRouter, Navigate } from "react-router-dom";
import PlatformLayout from "./PlatformLayout";
import TenantListPage from "./TenantListPage";
import TenantCreatePage from "./TenantCreatePage";
import TenantDetailPage from "./TenantDetailPage";

const platformRouter = createBrowserRouter([
	{
		path: "/",
		element: <PlatformLayout />,
		children: [
			{ path: "/", element: <Navigate to="/tenants" replace /> },
			{ path: "/tenants", element: <TenantListPage /> },
			{ path: "/tenants/new", element: <TenantCreatePage /> },
			{ path: "/tenants/:id", element: <TenantDetailPage /> },
		],
	},
]);

export default platformRouter;
